import { t } from "ember-intl";
import constantToSentenceCase from "glesys-controlpanel/helpers/constant-to-sentence-case";
import PageContent from "glesys-controlpanel/components/page-content";
import PageContentServiceIntro from "glesys-controlpanel/components/page-content/service-intro";
import Entity from "glesys-controlpanel/components/entity";
import EntityField from "glesys-controlpanel/components/entity/fields/field";
import EntityList from "glesys-controlpanel/components/entity-list";
import CostPlain from "glesys-controlpanel/components/cost/plain";
import EmptyState from "glesys-controlpanel/components/empty-state";
import IconsSidebarNetworking from "glesys-controlpanel/components/icons/sidebar/networking";
import { array } from "@ember/helper";

<template>
  <PageContent>
    <PageContentServiceIntro
      @title={{t "network-circuits.page-title"}}
      @description={{t "network-circuits.page-description"}}
    />

    <EntityList @items={{@model.networkCircuits}}>
      <:default as |networkCircuit|>
        <Entity @title={{networkCircuit.id}}>
          <:fields>
            <EntityField data-test-network-circuit-type @label={{t "label.type"}}>
              {{if networkCircuit.type (constantToSentenceCase networkCircuit.type) "—"}}
            </EntityField>
            <EntityField data-test-network-circuit-cost @label={{t "label.cost"}}>
              <CostPlain
                @currency={{networkCircuit.billing.currency}}
                @price={{networkCircuit.billing.price}}
                @discountedPrice={{networkCircuit.billing.total}}
              />
            </EntityField>
          </:fields>
        </Entity>
      </:default>
      <:empty>
        <EmptyState
          @icon={{IconsSidebarNetworking}}
          @title={{t "network-circuits.empty-state.title"}}
          @description={{t "network-circuits.empty-state.description"}}
          @points={{array
            (t "network-circuits.empty-state.usp-list.transit")
            (t "network-circuits.empty-state.usp-list.transport")
            (t "network-circuits.empty-state.usp-list.cross-connects")
          }}
          @learnMoreUrl="https://docs.glesys.com/products/connectivity/network-services"
          @learnMoreAriaLabel={{t "network-circuits.empty-state.learn-more-aria-label"}}
          @contactUrl={{t "network-circuits.empty-state.contact-url"}}
        />
      </:empty>
    </EntityList>
  </PageContent>
</template>
